import {combineReducers} from 'redux';
import accountsettings from './accountsettings/reducer';
import billing from './billing/reducer';

export default combineReducers({
  accountsettings,
  billing,
});
